
import React, { useState, useLayoutEffect, useEffect } from "react";
import {
  TextField,
  Link,
  Box,
  Typography,
  Paper,
  IconButton,
  InputAdornment,
  Button,
  CircularProgress,
  Fade,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

import apiClient from "../BaseUrl/apiClient";
import TokenService from "../service/TokenService";
import EncryptService from "../service/EncryptionService";
import logo from "../photo/logo.jpg";
import { useAuthentication } from "../customHook/useAuthentecation";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import VerifiedUserRoundedIcon from "@mui/icons-material/VerifiedUserRounded";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import BouncingBall from "../components/BouncingBall";

import BouncingBallGame from "../components/BouncingBallGame";





let email = "";
const theme = createTheme({
  palette: {
    primary: {
      main: "#1565C0",
      dark: "#0D47A1",
      light: "#1976D2",
    },
    secondary: {
      main: "#1976D2",
    },
  },

  typography: {
    fontFamily:
      '"Inter", "Roboto", "Helvetica", Arial, sans-serif',

    h5: {
      fontWeight: 700,
    },
  },

  shape: {
    borderRadius: 12,
  },
});
/* =========================================================
   FOOTER
========================================================= */

function Copyright() {
  return (
    <Typography
      component="div"
      align="center"
      sx={{
        fontSize: "10px",
        color: "#718096",
        lineHeight: 1.8,
      }}
    >
      Copyright ©{" "}
      <Link
        href="https://www.mwsgkp.in"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={{
          color: "#455a64",
          fontWeight: 600,
        }}
      >
        Mechanical Workshop, Gorakhpur
      </Link>{" "}
      {new Date().getFullYear()}
    </Typography>
  );
}

function Developer() {
  return (
    <Typography
      component="div"
      align="center"
      sx={{
        fontSize: "10px",
        color: "#718096",
        lineHeight: 1.8,
      }}
    >
      Software Developed by{" "}
      <Link
        href="https://www.sriyansh.com"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={{
          color: "#455a64",
          fontWeight: 600,
        }}
      >
        Sriyansh Computers
      </Link>
    </Typography>
  );
}

/* =========================================================
   MAIN COMPONENT
========================================================= */

export default function SignIn() {
  const [uname, setUname] = useState("");
  const [pastext, setPastext] = useState("");
  const [error, setError] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [loginData, setLoginData] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [ipp, setIpp] = useState("");

  const navigate = useNavigate();
  const { setAuth } = useAuthentication();

  /* =========================================================
     IP FETCH
  ========================================================= */

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setIpp(data.ip))
      .catch(() => {});
  }, []);

  useEffect(() => {
    sessionStorage.clear();
  }, []);

  /* =========================================================
     LOGIN LOGIC
  ========================================================= */

  const verifyOtp = (currentOtp = otp) => {
    try {
      if (error === currentOtp && currentOtp !== "") {
        TokenService.setTokenDetails(loginData);
        setAuth(loginData);

        sessionStorage.setItem(
          "token1",
          EncryptService.encrypt(ipp)
        );

        sessionStorage.setItem(
          "token3",
          EncryptService.encrypt("erterte")
        );

        sessionStorage.setItem(
          "token4",
          EncryptService.encrypt("dfgdfgdfg")
        );

        navigate("/dashboard");

        setOtp("");
        setUname("");
        setPastext("");
      }
    } finally {
      setButtonLoading(false);
    }
  };

  const getdata = async () => {
    try {
      setButtonLoading(true);

      const response = await apiClient.post("/getLoginData", {
        uname,
        pastext,
        ipp,
      });

      setLoginData(response.data[0]);

      email = response.data[0].emailid;

      await sendOtp();
    } catch {
      setError("Unexpected Error");
    } finally {
      setButtonLoading(false);
    }
  };

  const sendOtp = async () => {
    try {
      const res = await apiClient.post("/send-otp", {
        email,
      });

      setError(res.data.message);
      setOtpSent(true);
    } catch {
      setError("Failed Generate Captcha");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    getdata();
  };

  /* =========================================================
     PAGE BACKGROUND
  ========================================================= */

  useLayoutEffect(() => {
    document.body.style.margin = "0";
    document.body.style.background = "#f5f8fc";
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.margin = "";
      document.body.style.background = "";
      document.body.style.overflow = "";
    };
  }, []);

  /* =========================================================
     UI
  ========================================================= */

 return (
  <ThemeProvider theme={theme}>
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        position: "relative",
        overflow: "hidden",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        boxSizing: "border-box",

        background:
          "linear-gradient(135deg,#f5f9ff 0%,#edf5ff 48%,#f8fbff 100%)",
      }}
    >
      {/* =================================================
          TOP BLUE ANIMATED LIGHT
      ================================================= */}

      <Box
        sx={{
          position: "absolute",
          width: 420,
          height: 420,
          borderRadius: "50%",

          background:
            "radial-gradient(circle,rgba(21,101,192,0.16) 0%,rgba(21,101,192,0.06) 40%,transparent 72%)",

          top: -190,
          left: -120,

          filter: "blur(4px)",

          animation: "blueOrbTop 13s ease-in-out infinite",

          "@keyframes blueOrbTop": {
            "0%,100%": {
              transform: "translate(0px,0px) scale(1)",
            },
            "50%": {
              transform: "translate(100px,80px) scale(1.15)",
            },
          },
        }}
      />

      {/* =================================================
          BOTTOM BLUE ANIMATED LIGHT
      ================================================= */}

      <Box
        sx={{
          position: "absolute",
          width: 500,
          height: 500,
          borderRadius: "50%",

          background:
            "radial-gradient(circle,rgba(25,118,210,0.14) 0%,rgba(25,118,210,0.05) 42%,transparent 72%)",

          right: -200,
          bottom: -230,

          filter: "blur(4px)",

          animation: "blueOrbBottom 16s ease-in-out infinite",

          "@keyframes blueOrbBottom": {
            "0%,100%": {
              transform: "translate(0px,0px) scale(1)",
            },
            "50%": {
              transform: "translate(-90px,-70px) scale(1.12)",
            },
          },
        }}
      />

      {/* =================================================
          BOUNCING BALL GAME
      ================================================= */}

      <BouncingBallGame
        ballCount={18}
        minRadius={12}
        maxRadius={28}
        speed={2.2}
        mouseBreakRadius={25}
        clickBreakRadius={100}
      />

      {/* =================================================
          SUBTLE DASHBOARD GRID
      ================================================= */}

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          opacity: 0.55,
          pointerEvents: "none",

          backgroundImage: `
            linear-gradient(
              rgba(21,101,192,0.035) 1px,
              transparent 1px
            ),
            linear-gradient(
              90deg,
              rgba(21,101,192,0.035) 1px,
              transparent 1px
            )
          `,

          backgroundSize: "45px 45px",
        }}
      />

      {/* =================================================
          LOGIN CARD
      ================================================= */}

      <Fade in timeout={900}>
        <Paper
          elevation={0}
          sx={{
            position: "relative",
            zIndex: 5,

            width: {
              xs: "calc(100% - 24px)",
              sm: 450,
            },

            maxWidth: "450px",
            minWidth: 0,

            p: {
              xs: 2.5,
              sm: 4,
            },

            boxSizing: "border-box",

            borderRadius: "22px",

            background:
              "rgba(255,255,255,0.97)",

            border:
              "1px solid rgba(21,101,192,0.10)",

            boxShadow:
              "0 25px 70px rgba(13,71,161,0.14)",

            animation:
              "loginCard 6s ease-in-out infinite",

            "@keyframes loginCard": {
              "0%,100%": {
                transform: "translateY(0px)",
              },
              "50%": {
                transform: "translateY(-5px)",
              },
            },

            "@media (max-width:420px)": {
              p: 2,
              borderRadius: "18px",
            },
          }}
        >
          {/* =================================================
              LOGO
          ================================================= */}

          <Box
            sx={{
              textAlign: "center",
              mb: 2.5,
              width: "100%",
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                height: "auto",

                p: {
                  xs: 1.5,
                  sm: 2,
                },

                borderRadius: "20px",

                background: "#ffffff",

                border:
                  "1px solid #e4edf8",

                boxShadow:
                  "0 8px 25px rgba(13,71,161,0.10)",

                boxSizing: "border-box",
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Logo"
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  height: "auto",
                  display: "block",
                  borderRadius: "9px",
                  objectFit: "contain",
                }}
              />
            </Box>

            <Typography
              sx={{
                mt: 2,

                color: "#172033",

                fontSize: {
                  xs: "17px",
                  sm: "18px",
                },

                fontWeight: 800,

                letterSpacing: "-0.4px",
              }}
            >
              Secure Login
            </Typography>

            <Typography
              sx={{
                mt: 0.4,
                color: "#7a8799",
                fontSize: "12px",
              }}
            >
              Authorized access only
            </Typography>
          </Box>

          {/* =================================================
              SECURITY STATUS
          ================================================= */}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              gap: 0.8,

              mb: 2.2,
              py: 0.75,
              px: 2,

              borderRadius: "50px",

              background:
                "linear-gradient(90deg,#f2f7ff,#f7fbff)",

              border:
                "1px solid #dbe8f7",
            }}
          >
            <VerifiedUserRoundedIcon
              sx={{
                fontSize: 16,
                color: "#1976D2",
              }}
            />

            <Typography
              sx={{
                fontSize: "10.5px",
                color: "#1565C0",
                fontWeight: 700,
                letterSpacing: "0.2px",
              }}
            >
              Secure Authentication
            </Typography>
          </Box>

          {/* =================================================
              FORM
          ================================================= */}

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              width: "100%",
              minWidth: 0,
            }}
          >
            {/* =================================================
                USERNAME + PASSWORD
            ================================================= */}

            {!otpSent && (
              <>
                <TextField
                  fullWidth
                  label="User Name"
                  value={uname}
                  onChange={(e) =>
                    setUname(e.target.value.toLowerCase())
                  }
                  margin="normal"
                  size="small"
                  autoComplete="username"
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#7b8794",
                    },

                    "& .MuiOutlinedInput-root": {
                      color: "#172033",
                      borderRadius: "11px",
                      backgroundColor: "#f8fafc",
                      transition: "all 0.2s ease",

                      "& fieldset": {
                        borderColor: "#dce3eb",
                      },

                      "&:hover": {
                        backgroundColor: "#ffffff",
                      },

                      "&:hover fieldset": {
                        borderColor: "#9db9d8",
                      },

                      "&.Mui-focused": {
                        backgroundColor: "#ffffff",

                        boxShadow:
                          "0 0 0 3px rgba(21,101,192,0.08)",
                      },

                      "&.Mui-focused fieldset": {
                        borderColor: "#1565C0",
                        borderWidth: "1.5px",
                      },
                    },
                  }}
                />

                <TextField
                  fullWidth
                  label="Password"
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  value={pastext}
                  onChange={(e) =>
                    setPastext(e.target.value)
                  }
                  margin="normal"
                  size="small"
                  autoComplete="current-password"
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#7b8794",
                    },

                    "& .MuiOutlinedInput-root": {
                      color: "#172033",
                      borderRadius: "11px",
                      backgroundColor: "#f8fafc",
                      transition: "all 0.2s ease",

                      "& fieldset": {
                        borderColor: "#dce3eb",
                      },

                      "&:hover": {
                        backgroundColor: "#ffffff",
                      },

                      "&:hover fieldset": {
                        borderColor: "#9db9d8",
                      },

                      "&.Mui-focused": {
                        backgroundColor: "#ffffff",

                        boxShadow:
                          "0 0 0 3px rgba(21,101,192,0.08)",
                      },

                      "&.Mui-focused fieldset": {
                        borderColor: "#1565C0",
                        borderWidth: "1.5px",
                      },
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          type="button"
                          edge="end"
                          onClick={() =>
                            setShowPassword(
                              !showPassword
                            )
                          }
                          sx={{
                            color: "#78909c",

                            "&:hover": {
                              color: "#1565C0",
                              backgroundColor:
                                "rgba(21,101,192,0.06)",
                            },
                          }}
                        >
                          {showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                {/* =================================================
                    GENERATE CAPTCHA
                ================================================= */}

                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  disabled={buttonLoading}
                  startIcon={
                    buttonLoading ? (
                      <CircularProgress
                        size={17}
                        color="inherit"
                      />
                    ) : (
                      <LoginRoundedIcon />
                    )
                  }
                  sx={{
                    mt: 2.5,
                    py: 1.25,

                    borderRadius: "11px",

                    fontWeight: 700,
                    fontSize: "14px",
                    textTransform: "none",

                    background:
                      "linear-gradient(135deg,#0D47A1,#1565C0,#1976D2)",

                    boxShadow:
                      "0 8px 20px rgba(21,101,192,0.22)",

                    transition:
                      "all 0.25s ease",

                    "&:hover": {
                      background:
                        "linear-gradient(135deg,#0D47A1,#1565C0,#1976D2)",

                      transform:
                        "translateY(-2px)",

                      boxShadow:
                        "0 12px 28px rgba(21,101,192,0.28)",
                    },

                    "&:active": {
                      transform:
                        "translateY(0)",
                    },

                    "&.Mui-disabled": {
                      background: "#d7dce2",
                    },
                  }}
                >
                  {buttonLoading
                    ? "Generating..."
                    : "Generate Captcha"}
                </Button>
              </>
            )}

            {/* =================================================
                CAPTCHA DISPLAY
            ================================================= */}

            {otpSent && error && (
              <Fade in timeout={500}>
                <Box
                  sx={{
                    mt: 2,
                    mb: 2,

                    p: {
                      xs: 2,
                      sm: 2.5,
                    },

                    textAlign: "center",

                    borderRadius: "16px",

                    background:
                      "linear-gradient(135deg,#f4f8ff 0%,#f8fbff 100%)",

                    border:
                      "1px dashed rgba(21,101,192,0.35)",

                    boxShadow:
                      "0 6px 22px rgba(13,71,161,0.05)",
                  }}
                >
                  <SecurityRoundedIcon
                    sx={{
                      fontSize: 28,
                      color: "#1565C0",
                      mb: 0.5,
                    }}
                  />

                  <Typography
                    sx={{
                      fontSize: "10px",
                      letterSpacing: "2px",
                      color: "#7b8794",
                      fontWeight: 800,
                    }}
                  >
                    CAPTCHA CODE
                  </Typography>

                  <Typography
                    sx={{
                      mt: 1,

                      fontSize: {
                        xs: "26px",
                        sm: "30px",
                      },

                      fontWeight: 900,
                      letterSpacing: "7px",

                      color: "#0D47A1",

                      userSelect: "none",

                      textShadow:
                        "0 2px 8px rgba(13,71,161,0.12)",
                    }}
                  >
                    {error}
                  </Typography>
                </Box>
              </Fade>
            )}

            {/* =================================================
                CAPTCHA INPUT
            ================================================= */}

            {otpSent && (
              <Fade in timeout={600}>
                <TextField
                  fullWidth
                  label="Enter Captcha Code"
                  value={otp}
                  onChange={(e) => {
                    const val =
                      e.target.value.replace(
                        /\D/g,
                        ""
                      );

                    setOtp(val);

                    if (val.length === 6) {
                      verifyOtp(val);
                    }
                  }}
                  autoFocus
                  inputProps={{
                    maxLength: 6,
                    inputMode: "numeric",

                    style: {
                      textAlign: "center",
                      fontSize: "1.45rem",
                      fontWeight: "800",
                      letterSpacing: "0.6rem",
                    },
                  }}
                  sx={{
                    mt: 1,

                    "& .MuiInputLabel-root": {
                      color: "#7b8794",
                    },

                    "& .MuiOutlinedInput-root": {
                      color: "#172033",
                      borderRadius: "11px",
                      backgroundColor: "#f8fafc",

                      "& fieldset": {
                        borderColor: "#dce3eb",
                      },

                      "&:hover fieldset": {
                        borderColor: "#9db9d8",
                      },

                      "&.Mui-focused": {
                        backgroundColor: "#ffffff",

                        boxShadow:
                          "0 0 0 3px rgba(21,101,192,0.08)",
                      },

                      "&.Mui-focused fieldset": {
                        borderColor: "#1565C0",
                        borderWidth: "1.5px",
                      },
                    },
                  }}
                />
              </Fade>
            )}
          </Box>

          {/* =================================================
              FOOTER
          ================================================= */}

          <Box
            sx={{
              mt: 3,
              pt: 2,

              borderTop:
                "1px solid #e7edf5",

              width: "100%",
            }}
          >
            <Copyright />
            <Developer />
          </Box>
        </Paper>
      </Fade>
    </Box>
  </ThemeProvider>
);
}

